// eslint-disable-next-line
/* global __DEVTOOLS__ */
import { createStore, compose, applyMiddleware } from "redux";
import { routerMiddleware } from "react-router-redux";
import { browserHistory } from "react-router";
import { createLogger } from "redux-logger";

import { thunk } from "redux-thunk";

import reducers from "../reducers";

export default function configureStore(initialState = {}) {
  const reduxRouterMiddleware = routerMiddleware(browserHistory);

  const logger = createLogger({
    collapsed: () => true,
    // diff: true,
  });

  let middlewares = [thunk, reduxRouterMiddleware];

  if (process.env.NODE_ENV !== "production") {
    middlewares = [logger, ...middlewares];
  }

  const finalCreateStore = compose(applyMiddleware(...middlewares))(
    createStore
  );

  const store = finalCreateStore(reducers, initialState);

  /*
  if (module.hot) {
    module.hot.accept('../reducers', () => {
      import('../reducers').then(nextRootReducer => {
        store.replaceReducer(nextRootReducer.default);
      });
    });
  }
  */

  return store;
}
